import { Size } from '../data/common';
import { Color } from '../svg/svg';
import { getPaletteColor, colorToString, adjustColor } from '../util/color';
import { Map as TLMDMap } from '../map/map';
import { TimelineOverlay, TimelineLayout, TimelineOverlayDatumContentProducer, TimelineOverlayCategory } from '../timeline/timeline-overlay';
import { Visualizer, VisualizerControl, VisualizationUpdateLevel } from '../data-source/visualizer';

import { ObservationDataSource } from './observation';
import { ObservationTypeDefinition } from './container-observation';



export class ObservationTimelineVisualizer extends TimelineOverlay implements Visualizer {
	private controls: { [key: string]: VisualizerControl }

	public constructor(private visualizerKey: string, private source: ObservationDataSource, className: string) {
		super(
			TimelineOverlayCategory.OBSERVATION,
			className,
			{
				eventHandlers: {
					'click': (evAndTrgt, _data) => {
						evAndTrgt.event.preventDefault();

						let overlayItem = (<TimelineOverlayDatumContentProducer>this.getProducer()).getItem(evAndTrgt.target.id);
						if (overlayItem) {
							source.getApplication().getInspectionPanel().switchContainer(overlayItem.group).then(_containerPanel => {

								source.onSelection(overlayItem.group, overlayItem.item.dataItemIds);
							});

						}
					}
				},
				elementData: {
					'source': source.getName(),
					'visualizer': visualizerKey
				}
			},
			new TimelineOverlayDatumContentProducer(
				{
					size: () => { return { width: 15, height: 15, border: 2 }; },
					draw: (domElem, meta, size: Size, _animationScript, _localProjection) => {
						// dataItem0 is first datum in cluster
						let dataItem0: any = meta.dataItems[meta.dataItemIds[0]];
						let typeDefinition = <ObservationTypeDefinition>source.getDefinitions()[dataItem0.type];

						if (typeDefinition.properties.hue !== undefined) {
							let baseColor = getPaletteColor(0, typeDefinition.properties.hue);
							domElem.style.backgroundColor = colorToString(adjustColor(baseColor, { hue: 0, saturation: 0, lightness: 0, alpha: -0.5 }));
							domElem.style.borderColor = colorToString(adjustColor(baseColor, { hue: 0, saturation: 0, lightness: (baseColor.lightness * 0.5), alpha: 0 }));
						} else if ((<Color>typeDefinition.properties.color).hue) {
							let baseColor = <Color>typeDefinition.properties.color;
							domElem.style.backgroundColor = colorToString(adjustColor(baseColor, { hue: 0, saturation: 0, lightness: 0, alpha: -0.5 }));
							domElem.style.borderColor = colorToString(adjustColor(baseColor, { hue: 0, saturation: 0, lightness: (baseColor.lightness * 0.5), alpha: 0 }));
						} else {
							domElem.style.backgroundColor = <string>typeDefinition.properties.color;
							domElem.style.borderColor = '#FFFFFF';
						}
						domElem.style.color = domElem.style.backgroundColor;
						domElem.style.borderWidth = `${size.border}px`;

						// add div for the number of underlying observations when count greater than 1
						if (meta.count > 1) {
							domElem.innerHTML = `<div class="tlmd-marker-label" style="left:${meta.visiblePX.start.local}px; width:${meta.visiblePX.end.local - meta.visiblePX.start.local - (2 * size.border)}px;"><div>${meta.count}</div></div>`
						}

					}
				},
				source,
				{
					layout: TimelineLayout.combine,
					padding: 3,
					marginGroup: 3,
					marginRow: 2
				}));

	}

	public key(): string {
		return this.visualizerKey;
	}

	public type(): string {
		//this visualizer is multi type
		return undefined;
	}

	public setControls(controls: { [key: string]: VisualizerControl }): Visualizer {
		this.controls = controls;
		return this;
	}


	public setMap(_map: TLMDMap): void {
		//we do not deal with the map here
	}

	public updateSelection(): void {
		(<TimelineOverlayDatumContentProducer>this.getProducer()).highlight(this.getLayer());
	}

	public refresh(_level: VisualizationUpdateLevel): void {
		//TODO use the level parameter for optimizations
		if (this.controls) {

			let types = Object.entries(this.controls)
				.filter(controlEntry => controlEntry[1].enabled(this.key()))
				.map(controlEntry => controlEntry[0]);

			let dataMap = this.source.getData(types);

			(<TimelineOverlayDatumContentProducer>this.getProducer()).setAnimationPosition(this.source.getTimeline().getCursorMillis(true));
			(<TimelineOverlayDatumContentProducer>this.getProducer()).setData(dataMap);

			this.update();
		}
	}

}
